/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { Chip } from 'uikit/chips';

import styles from '../styles/selectedChip.module.scss';

const SelectedChip = ({
  handleRemoveSelected = () => {},
  isReadOnly = false,
  selectedItem: { hex_color: color, id, name },
}) => (
  <li className={styles.element}>
    <Chip
      color={color}
      text={name}
      onClick={!isReadOnly ? () => handleRemoveSelected(id) : undefined}
    />
  </li>
);

SelectedChip.propTypes = {
  selectedItem: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    body: PropTypes.arrayOf(PropTypes.string),
    hex_color: PropTypes.string,
  }).isRequired,
  isReadOnly: PropTypes.bool,
  handleRemoveSelected: PropTypes.func,
};

export default React.memo(SelectedChip);
